import { GraphErrors } from './errors';

type DeleteErrorType = 'DEFAULT' | 'DELETED_THREAD' | 'DELETED_COMMENT';
export class DeleteError extends GraphErrors {
  constructor(public readonly key: DeleteErrorType = 'DEFAULT') {
    super(key);
    this.name = 'DeleteErrors';
  }
}
